import { loadable } from '../../../common/utils/lazyLoading';
const Translation = loadable(() => import('../Translation/index'));
// TODO abeer: Add translation module permission
export default [
    {
        id: 'translation',
        title: 'Translation',
        route: 'translation',
        permission: 'administration.translation',
        component: Translation,
        icon: 'earth',
    },
];
